var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1256","data-name":"Path 1256","d":"M1305.473,544.417h3.818v6.609h-3.818Zm10.118,0h-3.819v6.609h3.819Zm-12.6,0h-3.819v6.609h3.819Zm2.483,8.606h3.818v6.609h-3.818Zm10.118,0h-3.819v6.609h3.819Zm-12.6,0h-3.819v6.609h3.819Z","transform":"translate(-1299.171 -544.417)","fill":"#002560"}));
}

Grid.defaultProps = {"width":"16.42","height":"15.215","viewBox":"0 0 16.42 15.215"};

module.exports = Grid;

Grid.default = Grid;
